import { render } from "./UpdPassword.vue?vue&type=template&id=d981369a"
import script from "./UpdPassword.vue?vue&type=script&lang=js"
export * from "./UpdPassword.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__